import { addItemToCollection } from "directus/src/operations";

// Add createClient function
export async function createClient({ item }) {
  try {
    const data = await addItemToCollection("clients", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
